/**
 * Lọc danh sách theo nhiều nhóm, mỗi nhóm chọn được nhiều giá trị (kiểu bộ
 * lọc cột trái của ycombinator.com/companies). Hàm thuần, không đụng React.
 *
 * Quy tắc:
 * - Trong MỘT nhóm: khớp bất kỳ giá trị nào đã chọn (HOẶC).
 * - Giữa các nhóm: phải khớp tất cả nhóm có chọn (VÀ).
 * - Nhóm không chọn gì = không lọc theo nhóm đó.
 * - Số đếm cạnh mỗi lựa chọn = số mục sẽ hiện nếu tick thêm lựa chọn đó,
 *   tính khi giữ nguyên các nhóm KHÁC và ô tìm (giống cách YC đếm).
 *
 * Trên URL mỗi nhóm là một tham số, các giá trị nối bằng dấu phẩy:
 * ?tram=t1,t2&stage=SEED. Link cũ một giá trị (?tram=t1) vẫn đọc đúng.
 */

/** @typedef {{ key: string, giaTri: (item: any) => string[], khop?: (item: any, chon: string[]) => boolean }} NhomLoc */

/** Đọc danh sách giá trị đã chọn của một nhóm từ URLSearchParams. */
export function docChon(params, key) {
  const v = params.get(key);
  if (!v) return [];
  return [...new Set(v.split(',').map((x) => x.trim()).filter(Boolean))];
}

/** Trả về URLSearchParams mới với nhóm `key` mang các giá trị `ds` (rỗng thì xoá). */
export function ghiChon(params, key, ds) {
  const p = new URLSearchParams(params);
  if (ds && ds.length) p.set(key, [...new Set(ds)].join(','));
  else p.delete(key);
  return p;
}

/** Bật hoặc tắt một giá trị trong danh sách đã chọn. */
export function batTat(ds, v) {
  return ds.includes(v) ? ds.filter((x) => x !== v) : [...ds, v];
}

function khopNhom(nhom, item, chon) {
  if (!chon || !chon.length) return true;
  if (nhom.khop) return nhom.khop(item, chon);
  const gt = nhom.giaTri(item) || [];
  return chon.some((v) => gt.includes(v));
}

/**
 * @param {any[]} items
 * @param {NhomLoc[]} nhom
 * @param {Record<string, string[]>} chon  giá trị đã chọn theo key nhóm
 * @param {(item: any) => boolean} [them]  điều kiện chung (ô tìm, phạm vi trang)
 * @returns {{ ketQua: any[], dem: Record<string, Record<string, number>> }}
 */
export function locVaDem(items, nhom, chon = {}, them = () => true) {
  const coSan = items.filter(them);
  const ketQua = coSan.filter((it) => nhom.every((g) => khopNhom(g, it, chon[g.key])));
  const dem = {};
  for (const g of nhom) {
    const d = {};
    for (const it of coSan) {
      if (!nhom.every((k) => k === g || khopNhom(k, it, chon[k.key]))) continue;
      for (const v of new Set(g.giaTri(it) || [])) d[v] = (d[v] || 0) + 1;
    }
    dem[g.key] = d;
  }
  return { ketQua, dem };
}
